import { createRoot } from "react-dom/client";

import { caches, toggles } from "@src/dependencies";
import Router from "@src/router";

import AppContext from "@context/app.context";
import MenuBuilderContext from "@context/menu-builder-context";
import NotificationContext from "@context/notification.context";
import OrganizationContext from "@context/organization.context";
import SessionContext from "@context/session.context";
import UsersContext from "@context/users.context";

import { initIcons } from "@lib/icon-set";

import "./index.scss";

initIcons();
const appRoot = document.querySelector("#root");
const { userCache, tokenCache } = caches;

createRoot(appRoot).render(
  <SessionContext
    userCache={userCache}
    tokenCache={tokenCache}
    toggles={toggles}
  >
    <AppContext>
      <NotificationContext>
        <UsersContext>
          <OrganizationContext>
            <MenuBuilderContext>
              <Router />
            </MenuBuilderContext>
          </OrganizationContext>
        </UsersContext>
      </NotificationContext>
    </AppContext>
  </SessionContext>,
);
